import React from 'react';

export default function InstructionsPage() {
  return (
    <div style={{
      maxWidth: '800px',
      margin: '2rem auto',
      padding: '2rem',
      border: '1px solid #ccc',
      borderRadius: '8px',
      backgroundColor: '#f9f9f9',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h2 style={{ textAlign: 'center', color: '#2b6cb0' }}>NEXUS upitnik za nagradjivanje JLS</h2>
      <p>
        Dobro došli na platformu za nagrađivanje lokalnih zajednica. Prije nego što pristupite upitniku, 
        molimo vas da pažljivo popunite svoj profil. Nakon popunjavanja profila dobićete mogućnost 
        da odgovarate na pitanja kroz 4 kategorije.
      </p>
      <ul style={{ marginTop: '1rem', paddingLeft: '1.5rem' }}>
        <li>Pažljivo pročitajte svako pitanje.</li>
        <li>Odgovarajte tačno i iskreno na osnovu dostupnih podataka vaše lokalne zajednice.</li>
        <li>Ako imate nejasnoća, možete se obratiti podršci.</li>
      </ul>
      <p style={{ marginTop: '1rem' }}>
        Hvala na vašem doprinosu!
      </p>
    </div>
  );
}
